<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2201_10413)">
<mask id="path-2-inside-1_2201_10413" fill="white">
<rect x="10.5" y="9.25" width="13" height="7" rx="1"/>
</mask>
<rect x="10.5" y="9.25" width="13" height="7" rx="1" stroke="currentColor" stroke-width="3.4" mask="url(#path-2-inside-1_2201_10413)"/>
<path d="M13.6653 22.4304L20.3347 22.4304" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
<path d="M17 19.0957L17 25.765" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
</g>
<defs>
<clipPath id="clip0_2201_10413">
<rect width="22" height="22" fill="white" transform="translate(6.5 6.25)"/>
</clipPath>
</defs>
</svg>
